// extracted by css-extract-rspack-plugin
export default {"gridStretch":"vu2X7KX3n_YRndkW"};